module.exports = __webpack_public_path__ + "media/images/rewards/Icon-08450c2c0525c6682acbc5bcd4c2dc27.svg";